import { useQuery } from '@apollo/client';
import {CART} from "../productTypeDefs";

export const useQueryCart = (options?: any): any => (
  useQuery(CART, options)
);
